import { useEffect } from 'react'

import { useToast } from '@zet/common/components/toast'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { AgentDetails } from '@zet/customer'
import { i18n } from '@zet/localization'

import {
  useGenerateSharableLink,
  useProductFlowRecommendations,
} from '../api/brands/hooks'
import { BottomsheetTypes } from '../api/brands/types'
import { useApplyLink } from './useApplyLink'

const useProductFlowApply = (
  agentData: AgentDetails,
  handleBottomsheetState: (state: BottomsheetTypes, data: any) => void
) => {
  const toast = useToast()
  const { navigate } = useNavigation()
  const { mutate: getProductFlowRecommendation } =
    useProductFlowRecommendations()
  const {
    mutate: fetchShareLink,
    isLoading: shareLinkLoading,
    data: shareLinkData,
    isSuccess,
  } = useGenerateSharableLink()
  const { handleApply } = useApplyLink(
    shareLinkData,
    agentData?.partnerId,
    sessionStorage.getItem('fullName'),
    sessionStorage.getItem('customerId'),
    sessionStorage.getItem('phoneNumber'),
    true
  )
  function closeBottomSheet() {
    handleBottomsheetState(null, null)
  }
  useEffect(() => {
    if (isSuccess && shareLinkData) {
      handleApply()
      closeBottomSheet()
    }
  }, [isSuccess, shareLinkData])
  const apply = () => {
    getProductFlowRecommendation(
      {
        customerId: sessionStorage.getItem('customerId') as string,
        partnerId: agentData?.partnerId,
      },
      {
        onSuccess(specificBrandsData) {
          if (specificBrandsData?.value) {
            fetchShareLink(
              {
                partnerId: Number(agentData?.partnerId),
                customerId: sessionStorage.getItem('customerId'),
                leadSource: 'webBrand',
                brandSpecificPartnerId: Number(agentData?.partnerId),
              },
              {
                onError(err: {
                  response: { data: { error: { message: any } } }
                }) {
                  toast?.show({
                    intent: 'error',
                    heading: i18n.t('toastMessages.error'),
                    description:
                      err?.response?.data?.error?.message ||
                      i18n.t('toastMessages.somethingWentWrong'),
                    hideAfter: 3000,
                  })
                },
              }
            )
          } else {
            closeBottomSheet()
            navigate('BrandPage', {
              customerId: sessionStorage.getItem('customerId'),
              customerName: sessionStorage.getItem('fullName'),
              customerPhoneNumber: sessionStorage.getItem('phoneNumber'),
              brandSpecificPartnerId: agentData?.partnerId,
              isBureauReportExpired: false,
            })
          }
        },
        onError(err) {
          toast?.show({
            intent: 'error',
            heading: i18n.t('toastMessages.error'),
            description:
              err?.response?.data?.error?.message ||
              i18n.t('toastMessages.somethingWentWrong'),
            hideAfter: 3000,
          })
        },
      }
    )
  }
  return { apply, shareLinkLoading }
}

export { useProductFlowApply }
